// エラーフォーマット用のヘルパー関数
const formatServerResponse = (data) => {
  if (typeof data === 'string') {
    return data
  }
  if (typeof data === 'object') {
    try {
      return JSON.stringify(data, null, 2)
    } catch {
      return '[Object - JSON stringify failed]'
    }
  }
  return String(data)
}

/**
 * エラーオブジェクトを拡張して、より詳細な情報を含むメッセージを生成します。
 * @param error
 * @param errorMessagePrefix
 */
export const extendErrorMessageObject = (
  error: Error & any,
  {
    prefix = '',
    includeStack = true,
  }: {
    prefix?: string
    includeStack?: boolean
  }
) => {
  const response = error.response || error.parent?.response
  if (response) {
    // サーバーからレスポンスがある場合
    const serverResponse = response.data || response.raw
    const statusCode = response.status
    const statusText = response.statusText
    const requestConfig = error.config || error.parent?.config || {}
    const url = requestConfig?.url || 'Unknown URL'
    const method = requestConfig?.method?.toUpperCase() || 'Unknown Method'

    // 元のエラーメッセージを拡張
    const originalMessage = error.message || 'Unknown error'

    // あなたの現在の形式に合わせてフォーマット
    error.message = `API Error: [[${method}]${url}] ${originalMessage}\n- [Server Response]: ${formatServerResponse(serverResponse)}${includeStack ? `\n- [Stack Trace]: ${error.stack || 'No stack trace available'}` : ''}`

    // 追加のプロパティを設定（必要に応じて）
    error.serverResponse = serverResponse
    error.statusCode = statusCode
    error.statusText = statusText
    error.requestUrl = url
    error.requestMethod = method

    // rawレスポンスも含める（あなたのコードの e.response?.raw に相当）
    error.response.raw = formatServerResponse(serverResponse)

  } else if (error.request) {
    // リクエストは送信されたがレスポンスがない場合
    const url = error.config?.url || 'Unknown URL'
    const method = error.config?.method?.toUpperCase() || 'Unknown Method'
    error.message = `[${method} ${url} - Network Error] ${error.message || 'No response received from server'}`

  } else {
    // リクエスト設定時にエラーが発生した場合
    error.message = `[Request Setup Error] ${error.message}`
  }
  if (prefix) {
    error.message = `${prefix}${error.message}`
  }
  return error
}// エラーオブジェクトを拡張
